import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

require('../../../../icons/loading.svg');

@Component({
  template: require('./icon.html'),
  name: 'wc-icon'
})
export class Icon extends Vue {

  @Prop()
  name: string;

  @Prop()
  className: string;

  @Prop()
  loading: boolean;

  get iconClass() {
    let className = this.className ? this.className : 'wc-icon';
    return this.loading ? `${className} spin` : className;
  }

  get iconHref() {
    let name = this.loading ? 'loading' : this.name;
    if (name.indexOf('#') < 0) name = '#' + name;
    return name;
  }

}


//Vue.component('wc-icon', Icon);



// WEBPACK FOOTER //
// src/../~/wc-lib/src/wc-ui/components/icon/icon.ts